import { PageHeader, Select, Space, Tag, Tooltip } from "antd";
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import { FileSearchOutlined, TagOutlined } from "@ant-design/icons";
import { ButtonItem, SelectItem, TableItemDinamico } from "../../../Components/Items";
import round4Decimals from "../../../Components/round4Decimals";
import moment from "moment";
import ModalEtiquetasLote from "./ModalEtiquetasLote/ModalEtiquetasLote";

const { Option } = Select;

class Lotes extends Component {
    tableRef = null;
    state = {
        loading: false,
        objetoProyectos: [],
        todasProyectos: [],
        todasLotes: [],
        proyecto: undefined,
        proyectoId: undefined,
        filtrosFamilias: [],
        filtrosTipoInsumos: [],
        valor: 5,
        totalRecords: 0,
        rangosLeyenda: [],
        usarColores: false,
        modalEtiquetasLote: false,
        modalEtiquetasLoteId: null,
        modalEtiquetasLoteNumero: null,
    };

    abrirEtiquetasLote(record) {
        this.setState({
            modalEtiquetasLote: true,
            modalEtiquetasLoteId: record._id,
            modalEtiquetasLoteNumero: record.numero,
        });
    }

    cerrarEtiquetasLote() {
        this.setState({
            modalEtiquetasLote: false,
            modalEtiquetasLoteId: null,
            modalEtiquetasLoteNumero: null,
        });
    }

    async consultarConfiguracionLotes() {
        axios
            .post(
                "lotes/selectConfiguracionLotes",
                { empresaId: this.props.empresaId },
                { headers: this.props.headersToken }
            )
            .then((res) => {
                if (res.data.success === 2) {
                    this.setState({
                        usarColores: res.data.usarColoresLotes,
                        rangosLeyenda: res.data.rangosLotes || [],
                    });
                }
            });
    }

    async consultarLotes(params) {
        this.setState({ loading: true });

        const payload = {
            empresaId: this.props.empresaId,
            ...params,
            limit: params.pageSize,
        };

        if (this.state.proyectoId) {
            payload.proyectoId = this.state.proyectoId;
        }

        await axios
            .post("lotes/selectTodasLotes", payload, {
                headers: this.props.headersToken,
            })
            .then((res) => {
                if (res.data.success === 2) {
                    this.setState({
                        todasLotes: res.data.data || res.data,
                        totalRecords: res.data.totalRecords || (res.data.length ? res.data.length : 0),
                    });
                } else {
                    this.setState({ todasLotes: [], totalRecords: 0, loading: false });
                }
            })
            .catch((error) => {
                console.error("Error al consultar lotes:", error);
                this.setState({ todasLotes: [], loading: false });
            });
        this.setState({ loading: false });
    }

    async componentDidMount() {
        this.setState({ loading: true });

        const [resProyectos] = await Promise.all([
            axios.post(
                "proyectos/selectProyectos",
                { empresaId: this.props.empresaId },
                { headers: this.props.headersToken }
            ),
        ]);

        if (resProyectos.data.status !== 404) {
            this.setState({
                todasProyectos: resProyectos.data,
                objetoProyectos: resProyectos.data.map((value) => (
                    <Option value={value._id} key={value._id}>
                        {value.nombre}
                    </Option>
                )),
            });
        }

        this.consultarConfiguracionLotes();
    }

    onChangeProyecto(value) {
        if (value === 0) {
            this.setState({ loading: true, proyecto: undefined, proyectoId: undefined }, () => {
                if (this.tableRef) {
                    this.tableRef.updateExternalFilters({ proyectoId: undefined });
                }
            });
        } else {
            const proyecto = this.state.todasProyectos.find(valueState => valueState._id.toString() === value.toString());
            this.setState({ proyecto: proyecto.nombre, proyectoId: proyecto._id }, () => {
                if (this.tableRef) {
                    this.tableRef.updateExternalFilters({ proyectoId: proyecto._id });
                }
            });
        }
    }

    getIndiceRangoCaducidad(caducidad) {
        if (!caducidad || !this.state.usarColores || this.state.rangosLeyenda.length === 0) {
            return null;
        }

        const diasRestantes = moment(caducidad).diff(moment(), 'days');
        const rangosOrdenados = [...this.state.rangosLeyenda].sort((a, b) => a.tope - b.tope);

        for (let i = 0; i < rangosOrdenados.length; i++) {
            if (diasRestantes <= rangosOrdenados[i].tope) {
                return i;
            }
        }

        return null;
    }

    render() {
        const coloresFijos = [
            'rgba(236, 251, 241, 1)',
            'rgba(223, 247, 230, 1)',
            'rgba(255, 244, 204, 1)',
            'rgba(255, 226, 204, 1)',
            'rgba(255, 214, 214, 1)',
        ];

        const estadosLeyendaDinamicos = this.state.usarColores
            ? this.state.rangosLeyenda.map((rango, index) => ({
                color: rango.color || coloresFijos[index] || 'rgba(200, 200, 200, 1)',
                label: rango.nombre,
                key: `rango-${index}`,
                tope: rango.tope,
            }))
            : [];

        const cssFilasCaducidad = this.state.usarColores
            ? [...this.state.rangosLeyenda]
                .sort((a, b) => a.tope - b.tope)
                .map((rango, index) => {
                    const color = rango.color || coloresFijos[index] || 'rgba(200, 200, 200, 1)';
                    return `
                .fila-caducidad-${index} > td {
                    background-color: ${color} !important;
                }

                .fila-caducidad-${index}:hover > td {
                    background-color: ${color} !important;
                }
            `;
                })
                .join("\n")
            : "";

        const columns = [
            {
                title: <span style={{ whiteSpace: "normal", wordBreak: "break-word", display: "block", lineHeight: 1.3 }}>Clave / Código de Barras</span>,
                key: "claveCodigoBarras",
                width: "13%",
                render: (record) => (
                    <div>
                        <div style={{ fontWeight: 400, color: "#6a6a6a" }}>{record.clave}</div>
                        <div style={{ color: "#000000", fontSize: "12px", fontWeight: 500 }}>{record.codigoBarras}</div>
                    </div>
                ),
            },
            {
                title: "Descripción",
                dataIndex: "descripcion",
                key: "descripcion",
                width: "30%",
            },
            {
                title: "Proyecto",
                dataIndex: "proyectoNombre",
                key: "proyectoNombre",
                width: "30%",
            },
            {
                title: "Lote",
                dataIndex: "numero",
                key: "numero",
                width: "10%",
            },
            {
                title: "Caducidad",
                dataIndex: "caducidad",
                key: "caducidad",
                sorter: true,
                render: (value) => value ? moment(value).format("DD/MM/YYYY") : "",
                width: "10%",
            },
            {
                title: "Unidad",
                dataIndex: "unidadNombre",
                key: "unidadNombre",
                width: "10%",
            },
            {
                title: "Cantidad",
                dataIndex: "cantidad",
                key: "cantidad",
                width: "20%",
                render: (value) => round4Decimals(value).toFixed(4),
            },
            {
                title: "Estado",
                dataIndex: "estado",
                responsive: ["md"],
                key: "estado",
                render: (value, record, index) => {
                    if (value === 2) {
                        return (
                            <Tag key={index.toString()} color="blue" className="square-tag">
                                Apartado
                            </Tag>
                        )
                    }
                    if (value === 3) {
                        return (
                            <Tag key={index.toString()} color="orange" className="square-tag">
                                Consignación
                            </Tag>
                        )
                    }
                },
                width: "12%",
            },
            {
                title: "Acción",
                key: "accion",
                align: "center",
                render: (record, _row, index) => (
                    <Tooltip title="Imprimir etiqueta" placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
                        <ButtonItem
                            type="default"
                            size="small"
                            morado
                            icon={<TagOutlined />}
                            key={index.toString()}
                            onClick={(e) => {
                                e.stopPropagation();
                                this.abrirEtiquetasLote(record);
                            }}
                        />
                    </Tooltip>
                ),
                width: "8%",
            },
        ];

        return (
            <>
                <style>{cssFilasCaducidad}</style>

                <PageHeader
                    title={this.state.proyecto ? "Lotes: " + this.state.proyecto : "Lotes: Todos"}
                    style={{
                        border: "1px solid rgb(235, 237, 240)",
                        backgroundColor: "white",
                        marginBottom: 10,
                    }}
                    extra={
                        <Space style={{ width: "100%" }}>
                            <SelectItem
                                placeholder="Proyecto"
                                width={200}
                                onChange={this.onChangeProyecto.bind(this)}
                                defaultValue={0}
                            >
                                <Option value={0}>Todos</Option>
                                {this.state.objetoProyectos}
                            </SelectItem>
                            {this.props.taxidermia && (
                                <ButtonItem
                                    type="primary"
                                    icon={<FileSearchOutlined />}
                                    onClick={() => this.props.history.push("/panel/archivosLotes")}
                                >
                                    Buscar Archivos
                                </ButtonItem>
                            )}
                        </Space>
                    }
                />
                <TableItemDinamico
                    ref={(ref) => this.tableRef = ref}
                    onRef={(ref) => this.tableRef = ref}
                    onFetchData={this.consultarLotes.bind(this)}
                    totalRecords={this.state.totalRecords}
                    dataSource={this.state.todasLotes || []}
                    loading={this.state.loading}
                    columns={columns}
                    size="small"
                    pagination={false}
                    estadosLeyenda={estadosLeyendaDinamicos}
                    setTextoFiltro={(textoFiltro) => this.setState({ textoFiltro })}
                    valorTextoDefault={""}
                    filterStorageKey={"lotesFiltrosTabla" + this.props.empresaId}
                    rowClassName={(record, index) => {
                        const indice = this.getIndiceRangoCaducidad(record.caducidad);
                        if (indice || indice === 0) {
                            return `fila-caducidad-${indice}`;
                        } else {
                            if (index % 2 === 0) {
                                return 'zebra-gris'
                            }
                            return 'default'
                        }
                    }}
                    onRow={(record, rowIndex) => {
                        return {
                            onDoubleClick: (event) => {
                                this.props.history.push("/panel/lotesInsumo", {
                                    id: record.insumoId || record._id,
                                    proyectoId: this.state.proyectoId,
                                });
                            },
                        };
                    }}
                />
                <ModalEtiquetasLote
                    visible={this.state.modalEtiquetasLote}
                    loteId={this.state.modalEtiquetasLoteId}
                    loteNumero={this.state.modalEtiquetasLoteNumero}
                    onCancel={this.cerrarEtiquetasLote.bind(this)}
                />
            </>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        headersToken: state.user.headersToken,
        empresaId: state.empresa.id,
        // El buscador de archivos solo aplica a empresas de taxidermia.
        taxidermia: state.empresa.taxidermia,
    };
};

export default connect(mapStateToProps)(Lotes);